import {Component, inject,} from '@angular/core';
import {StorageService } from '../../../../../projects/vendors/src/public-api';
import {hasAnyRole} from '../../../@application/roles';

@Component({
    selector: 'lib-ongoing-orders',
    templateUrl: './ongoing-orders.component.html',
    styleUrl: './ongoing-orders.component.css',
    standalone: false
})
export class OngoingOrdersComponent{

  // Resolves to the realm role `tg-smes_restaurant-pos:kitchen-staff`, which does not exist
  // yet - until it is created, everyone falls through to the all-orders view.
  kitchenStaff = ['KitchenStaff']
  isKitchenStaff: boolean
  private storageService = inject(StorageService)

  constructor() {
    const roles = this.storageService.getFromSessionStorage('roles') as string[] ?? [];
    this.isKitchenStaff = hasAnyRole(roles, this.kitchenStaff);
  }

}
